import { AxiosPromise } from "axios";
import { request } from "./request";

export const customerAccountApi = {
  findAll: (params?: Record<string, any>): AxiosPromise<any> =>
    request({
      url: `customer/customers/page/${params?.page ?? 1}`,
      method: "get",
      params,
    }),

  detail: (code: string): AxiosPromise<any> =>
    request({
      url: `/customer/customers/${code}`,
      method: "get",
    }),

  profile: (code: string): AxiosPromise<any> =>
    request({
      url: `/customer/profiles/customer/${code}`,
      method: "get",
    }),

  favorite: (code: string, params?: Record<string, any>): AxiosPromise<any> =>
    request({
      url: `/customer/favorite/customer/${code}/page/${params?.page ?? 1}`,
      method: "get",
      params,
    }),

  getExportId: (params?: Record<string, any>): AxiosPromise<any> =>
    request({
      url: `export/customers`,
      method: "get",
      params,
    }),

  getExportResult: (id: string): AxiosPromise<any> =>
    request({
      url: `export/result/${id}`,
      method: "get",
    }),
};
